module.exports = __webpack_public_path__ + "img/32-min.f38ec857.jpg";